export const CHANGE_AT_BROKERAGE = 'Alterar na corretora';

export const EXTERNAL_BILLING_STRATEGIES = {
  541: {
    url: 'https://bancodigital.modalmais.com.br/login',
  },
};
